

















import {Component, Vue, Prop} from 'vue-property-decorator'
import Button from './Button.vue'
import Layout from './proxy/Layout.vue'
import Container from './proxy/Container.vue'
import BadgeProfileImage from './profile/BadgeProfileImage.vue'
import {Action} from 'vuex-class'
import {Driver, Attachment, Profile} from '@/lib/kepler/interfaces'
import Flex from '@/components/proxy/Flex.vue'
import Icon from '@/components/proxy/Icon.vue'

@Component({
  components: {
    Icon,
    Flex,
    BadgeProfileImage,
    Container,
    Layout,
    Button,
  },
})
export default class ProfileWithImage extends Vue {

  @Prop({}) private driver!: Driver
  @Prop({
    default: false,
  }) private small?: boolean
  @Prop({
    default: 'manage',
  }) private button?: string

  @Action('addProfilePicture') private addProfilePicture!: any

  protected uploadImage(response: Attachment) {
    return this.addProfilePicture({attachment_token: response.token})
  }
}
